<script>
import { mapGetters, mapActions } from 'vuex';
import { required } from '@vuelidate/validators';
import { isPhoneE164OrEmpty, isNumber } from 'shared/helpers/Validators';
import useVuelidate from '@vuelidate/core';
import { reactive } from 'vue';

export default {
  props: {
    onSubmit: {
      type: [Function],
      default: () => {},
    },
  },
  setup() {
    const form = reactive({
      phoneNumber: '',
      phoneNumberId: '',
      businessAccountId: '',
      apiKey: '',
    });

    const validations = {
      phoneNumber: { required, isPhoneE164OrEmpty },
      phoneNumberId: { required, isNumber },
      businessAccountId: { required, isNumber },
      apiKey: { required },
    };

    const v$ = useVuelidate(validations, form);

    return { v$, form };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  methods: {
    ...mapActions('assistantWizard', ['next', 'updateChannelConfigItems']),
    sync() {
      const items = {
        provider: 'whatsapp_cloud',
        phone_number: this.form.phoneNumber,
        provider_config: {
          api_key: this.form.apiKey,
          phone_number_id: this.form.phoneNumberId,
          business_account_id: this.form.businessAccountId,
        },
      };

      this.updateChannelConfigItems({ channel: 'whatsapp', items });
    },
  },
};
</script>

<template>
  <form class="mx-0 flex flex-wrap justify-center" @submit.prevent="next()">
    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$ && v$.phoneNumber.$error }">
        {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.PHONE_NUMBER.LABEL') }}
        <input
          v-model.trim="form.phoneNumber"
          type="text"
          :placeholder="
            $t('ASSISTANT_MGMT.ADD.WHATSAPP.PHONE_NUMBER.PLACEHOLDER')
          "
          name="phone_number"
          @blur="v$.phoneNumber.$touch"
          @input="sync"
        />
        <span v-if="v$ && v$.phoneNumber.$error" class="message">
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.PHONE_NUMBER.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$ && v$.phoneNumberId.$error }">
        <span>
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.LABEL') }}
        </span>
        <input
          v-model.trim="form.phoneNumberId"
          type="text"
          :placeholder="
            $t('ASSISTANT_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.PLACEHOLDER')
          "
          @blur="v$.phoneNumberId.$touch"
          @input="sync"
        />
        <span v-if="v$ && v$.phoneNumberId.$error" class="message">
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.PHONE_NUMBER_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$ && v$.businessAccountId.$error }">
        <span>
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.LABEL') }}
        </span>
        <input
          v-model.trim="form.businessAccountId"
          type="text"
          :placeholder="
            $t('ASSISTANT_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.PLACEHOLDER')
          "
          @blur="v$.businessAccountId.$touch"
          @input="sync"
        />
        <span v-if="v$ && v$.businessAccountId.$error" class="message">
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.BUSINESS_ACCOUNT_ID.ERROR') }}
        </span>
      </label>
    </div>

    <div class="w-[65%] flex-shrink-0 flex-grow-0 max-w-[65%]">
      <label :class="{ error: v$ && v$.apiKey.$error }">
        <span>
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.API_KEY.LABEL') }}
        </span>
        <input
          v-model.trim="form.apiKey"
          type="text"
          :placeholder="$t('ASSISTANT_MGMT.ADD.WHATSAPP.API_KEY.PLACEHOLDER')"
          @blur="v$.apiKey.$touch"
          @input="sync"
        />
        <span v-if="v$ && v$.apiKey.$error" class="message">
          {{ $t('ASSISTANT_MGMT.ADD.WHATSAPP.API_KEY.ERROR') }}
        </span>
      </label>
    </div>
  </form>
</template>
